import { Skeleton } from '@rneui/base';
import { Stack } from '@components/primitives';
import React from 'react';
import styles from './styles';

interface SkeletonComponentProps {
  testID?: string;
  // Stack props
  row?: boolean;
  align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  spacing?: number;
  flex?: number;
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  style?: any;
}

const SkeletonComponent: React.FC<SkeletonComponentProps> = props => (
  <Stack testID="skeletonComponent" row align="center" spacing={4} {...props}>
    <Skeleton animation="wave" style={styles.skeletonParent} />
  </Stack>
);

export default SkeletonComponent;
